import { ReactNode } from "react";
import UploadDocumentButton from "../content/create-content-button";
import RecordImageUpload from "./record-image-upload";
import Typography from "../shared/typography";

interface MedicalRecordsSectionProps {
  title: string;
  buttonLabel: string;
  uploadMessage: string;
  hasRecords: boolean;
  emptyTitle: string;
  emptyDescription?: string;
  children: ReactNode;
}

export function MedicalRecordsSection({
  title,
  buttonLabel,
  uploadMessage,
  hasRecords,
  emptyTitle,
  emptyDescription,
  children,
}: MedicalRecordsSectionProps) {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="mb-10 flex flex-wrap justify-end gap-4">
        <div className="flex-shrink-0">
          <RecordImageUpload buttonLabel={buttonLabel} message={uploadMessage} />
        </div>
        <div className="flex-shrink-0">
          <UploadDocumentButton />
        </div>
      </div>

      {hasRecords ? (
        <Typography variant="h2" className="mb-8 text-terracotta-500">
          {title}
        </Typography>
      ) : (
        <div className="mt-4 text-center space-y-2">
          <Typography variant="h4" className="text-terracotta-500">
            {emptyTitle}
          </Typography>
          {emptyDescription && (
            <Typography variant="body1" className="text-terracotta-500">
              {emptyDescription}
            </Typography>
          )}
        </div>
      )}

      <div className="grid gap-4">{children}</div>
    </div>
  );
}

export default MedicalRecordsSection;
